import { render, staticRenderFns } from "./lesson_end.vue?vue&type=template&id=74054a10&scoped=true&"
import script from "./lesson_end.vue?vue&type=script&lang=js&"
export * from "./lesson_end.vue?vue&type=script&lang=js&"
import style0 from "./lesson_end.vue?vue&type=style&index=0&id=74054a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74054a10",
  null
  
)

export default component.exports